import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, Subject, timer } from 'rxjs';
import { catchError, concatMap, map, mergeMap, switchMap, withLatestFrom, takeUntil } from 'rxjs/operators';
import { FileService, NotificationService, PaginationService, RouterStateService } from '@rappider/services';
import * as ProjectExportActions from './project-export.actions';
import { PATH_DEFINITIONS, ProjectExportStatus, PROJECT_EXPORT_POLLING_TIME } from '@rappider/shared/definitions';
import { Router } from '@angular/router';
import { Navigate } from 'libs/shared/src/lib/states/router/router.actions';

@Injectable()
export class ProjectExportEffects {
  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private notificationService: NotificationService,
    private paginationService: PaginationService,
    private routerStateService: RouterStateService,
    private fileService: FileService,
    private router: Router
  ) { }

  /**
  /**
   * Set Project Export Pagination
   *
   * @memberof ProjectExportEffects
   */

  setPagination$ = createEffect(() => this.actions$.pipe(
    ofType<ProjectExportActions.SetPagination>(
      ProjectExportActions.ActionTypes.SetPagination
    ),
    mergeMap(action => {
      if (action.payload.getDataAfter) {
        // Removed GetProjectExports dispatch as it uses old API endpoint
        // Data is now handled by SyncRemoteDataService
        return [];
      } else {
        return [new ProjectExportActions.SetPaginationFailure({ error: 'There is no getDataAfter in payload', key: 'SetPaginationFailure', timestamp: Date.now() })];
      }
    })
  ));

  /**
   * export project
   *
   * @memberof ProjectEffects
   */
  // @Effect()
  // downloadExportedProject$ = this.actions$.pipe(
  //   ofType<ProjectExportActions.DownloadExportedProject>(
  //     ProjectExportActions.ActionTypes.DownloadExportedProject
  //   ),
  //   withLatestFrom(
  //     this.store.select(state => state.activeProject.data)
  //   ),
  //   mergeMap(([action, activeProject]) => {
  //     /* get project export id from payload */
  //     const projectExportId = action.payload.projectExport.id;
  //     /* get datetime variables */
  //     const nowDate = new Date();
  //     const yearStr = nowDate.getFullYear();
  //     const monthStr = nowDate.getMonth() < 10 ? `0${nowDate.getMonth() + 1}` : nowDate.getMonth();
  //     const dateStr = nowDate.getDate() < 10 ? `0${nowDate.getDate()}` : nowDate.getDate();
  //     const hourStr = nowDate.getHours() < 10 ? `0${nowDate.getHours()}` : nowDate.getHours();
  //     const minuteStr = nowDate.getMinutes() < 10 ? `0${nowDate.getMinutes()}` : nowDate.getMinutes();
  //     /* set full date string */
  //     const fullDateStr = `${yearStr}${monthStr}${dateStr}${hourStr}${minuteStr}`;
  //     /* set file name */
  //     const fileName = `${activeProject.key}_v${action.payload.projectExport.projectVersion.versionNumber}_${fullDateStr}.zip`;
  //     /* call download api */
  //     return this.projectExportApi.downloadExport({ projectExportId }).pipe(
  //       map((data: Blob) => new ProjectExportActions.DownloadExportedProjectSuccess({ data: data, fileName: fileName })),
  //       catchError(error => [
  //         new ProjectExportActions.ProjectExportError({ errorOn: 'DownloadExportedProject', error: error }),
  //       ])
  //     );
  //   })
  // );

  /**
   * export project
   *
   * @memberof ProjectEffects
   */
  // @Effect({ dispatch: false })
  // downloadExportedProjectSuccess$ = this.actions$.pipe(
  //   ofType<ProjectExportActions.DownloadExportedProjectSuccess>(
  //     ProjectExportActions.ActionTypes.DownloadExportedProjectSuccess
  //   ),
  //   map(action => {
  //     /* download file */
  //     this.fileService.downloadFile(action.payload.data, action.payload.fileName);
  //   })
  // );

}
